import { useEffect } from 'react';

import { fetchCapabilities } from 'flow/actions/app-actions';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectCapabilitiesLoaded } from 'flow/selectors/own-extension-selectors';

/**
 * Ensures capabilities are loaded before the transcription settings pages
 * render. Needed because mobile clients can deep-link directly to any of
 * these pages, bypassing the normal app init sequence.
 */
const useTranscriptionSettingsReady = () => {
    const dispatch = useAppDispatch();
    const capabilitiesLoaded = useAppSelector(selectCapabilitiesLoaded);

    useEffect(() => {
        if (!capabilitiesLoaded) {
            dispatch(fetchCapabilities);
        }
    }, [dispatch, capabilitiesLoaded]);

    return capabilitiesLoaded;
};

export default useTranscriptionSettingsReady;
